var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrapharrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 6H23.1428V12.8571",
    stroke: "#EE3138",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 6L13.4572 15.6857C13.297 15.8428 13.0815 15.9307 12.8572 15.9307C12.6328 15.9307 12.4174 15.8428 12.2572 15.6857L8.31432 11.7429C8.1541 11.5858 7.93868 11.4978 7.71432 11.4978C7.48996 11.4978 7.27455 11.5858 7.11432 11.7429L0.857178 18",
    stroke: "#EE3138",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapharrowIcon);
export default __webpack_public_path__ + "static/media/grapharrow_icon.482a45615a631d9f675cb88100685e90.svg";
export { ForwardRef as ReactComponent };